interface LimitBarProps {
  ideaCount: number;
  limit: number;
}

/** Free-plan meter in the sidebar (round 2 canvas "Free plan" card). */
export function LimitBar({ ideaCount, limit }: LimitBarProps) {
  const pct = Math.min(Math.round((ideaCount / limit) * 100), 100);
  const near = pct >= 80;

  return (
    <div className="sb-plan">
      <span className="sb-plan-row">
        <span className="sb-plan-name">Free plan</span>
        <span className={`sb-plan-meta${near ? ' sb-plan-warn' : ''}`}>{ideaCount} / {limit}</span>
      </span>
      <span
        className="sb-meter"
        role="meter"
        aria-label="Ideas used"
        aria-valuemin={0}
        aria-valuemax={limit}
        aria-valuenow={ideaCount}
      >
        <span className={`sb-meter-fill${near ? ' sb-meter-near' : ''}`} style={{ width: `${pct}%` }} />
      </span>
      <a href="/upgrade" className="sb-plan-link">Go Pro for unlimited ideas</a>
    </div>
  );
}
